import { render, staticRenderFns } from "./VSvgIcon.vue?vue&type=template&id=1698daa4&scoped=true"
import script from "./VSvgIcon.vue?vue&type=script&lang=js"
export * from "./VSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./VSvgIcon.vue?vue&type=style&index=0&id=1698daa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1698daa4",
  null
  
)

export default component.exports